import * as React from "react";
/**
 * Color Background icon rendered with the brand pink → purple gradient used
 * in the Plan details dialog navigation. Path data mirrors
 * `ColorBackgroundRegular` from `@fluentui/react-icons`; gradient stops are
 * sourced from the Figma redline
 */ export const ColorBackgroundGradient20 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2 10.66v2.84A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4H9.48l.67.67c.1.1.2.22.28.33h5.07c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-1.84l-1-1ZM5 1.5a.5.5 0 0 1 1 0v1.17a2 2 0 0 1 1.32.59l2.12 2.12a2 2 0 0 1 0 2.83l-2.83 2.83a2 2 0 0 1-2.82 0L1.66 8.9a2 2 0 0 1 0-2.82L4.5 3.26A2 2 0 0 1 5 2.89V1.5Zm0 4V4.16L2.66 6.5h6.32a1 1 0 0 0-.25-.41L6.61 3.96A1 1 0 0 0 6 3.68V5.5a.5.5 0 0 1-1 0Zm-2.92 2c0 .26.1.51.3.7l2.11 2.13a1 1 0 0 0 1.42 0L8.73 7.5H2.08Zm8.08.93 .22-.26a.5.5 0 0 1 .74 0l.22.26c.12.15.29.38.46.64.31.5.7 1.23.7 1.93 0 1-.67 2-1.75 2S9 12 9 11c0-.7.39-1.44.7-1.93.17-.26.34-.49.46-.64Zm.59.88c-.07.09-.14.19-.2.3-.31.47-.55 1-.55 1.39 0 .3.1.57.25.75.13.17.3.25.5.25s.37-.08.5-.25c.15-.18.25-.46.25-.75 0-.4-.24-.92-.55-1.4l-.2-.3Z",
        fill: "url(#paint0_color_bg_gradient_20)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_color_bg_gradient_20",
        x1: "3",
        y1: "1.5",
        x2: "13",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#DB6AEF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#7E6DFF"
    }))));
